import axios from 'axios';
import { API_CONFIG } from '../config/api.js';

class AuthService {
  static async checkAuth() {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/auth/me`, {
        withCredentials: true
      });
      return {
        isAuthenticated: true,
        user: response.data
      };
    } catch {
      return {
        isAuthenticated: false,
        user: null
      };
    }
  }

  static async logout() {
    try {
      await axios.post(`${API_CONFIG.BASE_URL}/auth/logout`, {}, {
        withCredentials: true
      });
      return true;
    } catch (error) {
      console.error('Logout failed:', error);
      return false;
    }
  }

  static redirectToLogin() {
    window.location.href = '/login';
  }
}

export default AuthService;
